import { FC, forwardRef } from 'react';
import { ButtonProps } from '@mui/material/Button';
import { Button } from './reset-button.styles';

const ResetButton: FC<ButtonProps> = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button variant="outlined" {...props} ref={ref} />
));

export default ResetButton;
